export const timeHelpers = {
  fromDateFormat(str) {
    const [year, month, day] = str.split('-');
    return new Date(`${year}/${month}/${day}`);
  },
  onSameDay(first, second){
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  },
  betweenDates(startDate, endDate, selectedDate) {
    return startDate <= selectedDate && endDate >= selectedDate;
  }
}
